import { Box } from "@mui/material";
import PlaceholderCmp, { ICON_TYPE } from "components/controls/PlaceholderCmp";
import PhotoCard from "pages/farms/photo/Card";
import { FunctionComponent } from "react";
import { Attachment } from "types/Attachment";



interface Props {
    photos: Attachment[]
    onPhotoClick?: (photo:Attachment) => void
}
const PhotosList: FunctionComponent<Props> = ({
    photos = [],
    onPhotoClick,
}) => {

    // STORE

    // HOOKs

    // HANDLERS

    // RENDER
    if (!photos?.length) return <PlaceholderCmp
        title="THERE ARE NO PHOTOS"
        iconType={ICON_TYPE.VOID}
    />

    return <>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {photos.map(photo =>
                <PhotoCard key={photo.id}
                    attach={photo}
                    onPhotoClick={() => onPhotoClick(photo)}
                />
            )}
        </Box>
    </>
}

export default PhotosList
